<template>
  <div ref="pdfContent" class="pdf-content">
    <CCard class="border-0">
      <CCardHeader v-if="!hideControls" class="no-print bg-transparent">
        <div class="float-right">
          <a href="#" class="btn btn-sm btn-info ml-1" @click="printContent">
            <CIcon name="cil-print" class="mr-1" /> Print
          </a>
        </div>
      </CCardHeader>
      <CCardBody>
        <div class="header">
          <CRow class="align-items-start mb-3">
            <CCol cols="3" md="2" class="text-left">
              <img :src="getImageUrl()" alt="Logo Syarikat" class="logo-image" />
            </CCol>
            <CCol cols="9" md="10" class="text-right company-info">
              <h1 class="company-name">{{ company.name }}</h1>
              <p class="company-tagline">{{ company.tagLine }}</p>
              <p class="company-regno">{{ '(' + company.regNo +')'}}</p>
              <p class="company-address" v-html="formatAddress(company.address)"></p>
              <p class="company-phone">Tel: {{ company.phone }}</p>
            </CCol>
          </CRow>
          <hr class="thick-hr" />
        </div>
        <div class="content-section">
          <h3 class="text-center">Finance · Used Cars · Insurance</h3>
          <br/>
          <p>{{ bank.name }}</p>
          <p v-html="formatAddress(bank.address)"></p>
          <br/>
          <p><strong>Tarikh:</strong> {{ getRegistrationDate() }}</p>
          <p>Tuan/Puan,</p>
          <p>
            <strong>
              Per: Nombor Akaun: {{ companyBankAccount.accountNo }} ({{ companyBankAccount.accountName }})
            </strong>
          </p>
          <hr/>
          <p>
            Dengan segala hormatnya merujuk kepada perkara di atas. Dengan ini, dimaklumkan bahawa pihak kami mempunyai Akaun {{ companyBankAccount.accountType }} dengan {{ companyBankAccount.name }} di cawangan {{ companyBankAccount.address }}. Segala urusniaga hendaklah dimasukkan terus ke dalam akaun seperti yang tertera di atas untuk tujuan semakan MITI dan akaun kami.
          </p>
          <p>
            Untuk makluman pihak tuan, di bawah ini kami sertakan nama dan nombor pendaftaran bagi kenderaan tersebut.
          </p>
          <p>
            <table class="table-borderless">
              <tr>
                <td>Nama:  </td>
                <td>  <strong>{{ getCustomerName() }}</strong></td>
              </tr>
              <tr>
                <td>No. Pendaftaran:  </td>
                <td>  <strong>{{  getPlateNo() }}</strong></td>
              </tr>
            </table>
          </p>
          <p>Kerjasama daripada pihak tuan amatlah di hargai.</p>
          <p>Sekian, terima kasih.</p>
          <br/>
          <p>Yang benar,</p>
          <br/>
          <br/>
          <br/>
          <div class="dotted-line"></div>
          <p><strong>{{ company.name }}</strong></p>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "WidgetsReportAccountNotice",
  props: {
    company: {
      type: Object,
      required: true,
      validator: (value) => {
        return [
          "name",
          "regNo",
          "tagLine",
          "address",
          "phone",
          "logoUrl",
          // "bankAccountName",
          // "bankAccountNo",
          // "bankName",
          // "bankAddress",
        ].every((prop) => prop in value);
      },
    },
    bank: {
      type: Object,
      required: true,
    },
    companyBankAccount: {
      type: Object,
      required: true,
    },
    stock: {
      type: Object,
      required: true,
    },
    hideControls: {
      type: Boolean,
      default: false,
    },

    // customer: {
    //   type: Object,
    //   required: true,
    //   validator: (value) => {
    //     return ["name", "registrationNumber"].every((prop) => prop in value);
    //   },
    // },
  },
  mounted() {
    this.forceA4Size();
  },
  methods: {
    forceA4Size() {
      const pdfContent = this.$refs.pdfContent;
      if (pdfContent) {
        pdfContent.style.width = "210mm";
      }
    },
    getPlateNo() {
      try {
        return this.stock.registration.vehicleRegistrationNumber;
      } catch (error) {
        return "N/A";
      }
    },
    getRegistrationDate() {
      try {
        const raw = this.stock && this.stock.registration && this.stock.registration.vehicleRegistrationDate;
        if (!raw) return "-";
        const d = new Date(raw);
        if (isNaN(d.getTime())) return "-";
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      } catch (e) {
        return "-";
      }
    },
    getCustomerName() {
      try {
        return this.stock.sale.customer.name;
      } catch (error) {
        return "N/A";
      }
    },
    removeTrailingSlash(str) {
      if (str.endsWith("/")) {
        return str.slice(0, -1);
      }
      return str;
    },
    getImageUrl() {
      var url = this.removeTrailingSlash(apiUrl) + this.company.logoUrl;
      // console.log(url);
      return url;
    },
    formatAddress(address) {
      if (!address) return "";
      return address.replace(/\n/g, "<br />");
    },
    saveAsPDF() {
      const element = this.$refs.pdfContent;
      const options = {
        margin: [0.5, 0.5, 0.5, 0.5], // Top, right, bottom, left
        filename: "Invoice_90-98792.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf().from(element).set(options).save();
    },
    printContent() {
      const printContents = this.$refs.pdfContent.innerHTML;
      const originalContents = document.body.innerHTML;

      document.body.innerHTML = printContents;

      window.print();

      document.body.innerHTML = originalContents;
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.thick-hr {
  border: 1px solid #000;
  margin: 10px 0;
}

.pdf-content {
  width: 210mm;
  max-width: 100%;
  margin: 0 auto;
  padding: 15mm;
  box-sizing: border-box;
  background-color: white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.4;
  color: #333;
}

.logo-image {
  max-width: 120px;
  height: auto;
  display: block;
}

.header {
  page-break-after: avoid;
  page-break-inside: avoid;
  margin-bottom: 15px;
}

.company-info {
  padding-left: 15px;
}

.company-name {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 5px;
  line-height: 1.2;
}

.company-tagline,
.company-regno,
.company-address,
.company-phone {
  margin-bottom: 3px;
  font-size: 11px;
  line-height: 1.3;
}

.content-section {
  page-break-inside: avoid;
}

.table-borderless {
  width: auto;
}

.table-borderless td,
.table-borderless th {
  border: 0;
  padding: 4px 8px;
  line-height: 1.2;
}

.dotted-line {
  border-bottom: 1px dotted #000;
  width: max-content;
  margin: 0 auto;
  padding-bottom: 5px;
}

@media print {
  .no-print {
    display: none !important;
  }

  .pdf-content {
    width: 794px;
    margin: 0;
    padding: 20px;
    box-shadow: none;
  }

  .pdf-content .card {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .pdf-content .card-body {
    padding: 0 !important;
  }

  .logo-image {
    max-width: 100px !important;
  }

  .company-name {
    font-size: 18px !important;
  }

  body {
    background: white;
  }
}

/* PDF Generation specific styles */
.pdf-content.pdf-generation {
  width: 794px !important;
  padding: 0 !important;
  margin: 0;
}

.pdf-content.pdf-generation .card {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.pdf-content.pdf-generation .card-body {
  padding: 0 !important;
}

.pdf-content.pdf-generation .no-print {
  display: none !important;
}

.pdf-content.pdf-generation .logo-image {
  max-width: 100px !important;
}

.pdf-content.pdf-generation .company-name {
  font-size: 18px !important;
}
</style>
